import {
  StackLayout,
  StackItem,
  ParagraphText,
} from "@leagueplatform/genesis-core";
import { useIntl } from "@leagueplatform/locales";
import { Logo } from "components/logo.component";
import { AppleStoreLink } from "components/app-store-links/apple-store-link.component";
import { GoogleStoreLink } from "components/app-store-links/google-store-link.component";

export const MarketingMicroSite = () => {
  const { formatMessage } = useIntl();

  return (
    <StackLayout spacing="$one" horizontalAlignment="center">
      <StackItem
        horizontalAlignment="center"
        css={{
          width: "100%",
          padding: "$twoAndHalf $oneAndHalf",
          backgroundColor: "$surfaceBackgroundTertiary",
        }}
      >
        <Logo width="320px" />
      </StackItem>
      <ParagraphText
        css={{
          padding: "$one $oneAndHalf 0",
          maxWidth: "700px",
          textAlign: "center",
          fontWeight: "$bodyOneSecondary",
        }}
      >
        {formatMessage({ id: "STR_MICROSITE_APP_ONLY_MESSAGE" })}
      </ParagraphText>
      <StackLayout
        spacing="$one"
        horizontalAlignment="center"
        orientation={{
          "@initial": "horizontal",
          "@mobile": "vertical",
        }}
        css={{ padding: "$oneAndHalf", maxWidth: "700px" }}
      >
        <AppleStoreLink />
        <GoogleStoreLink />
      </StackLayout>
    </StackLayout>
  );
};
